import { SCOPE_TYPE } from '@/types';

type CommunityAccessParams = {
  scopeTypes: SCOPE_TYPE[] | undefined;
};

export const hasCommunityAccess = ({ scopeTypes }: CommunityAccessParams): boolean => {
  if (!scopeTypes?.length) {
    return false;
  }

  return scopeTypes.includes(SCOPE_TYPE.CHURCH) || scopeTypes.includes(SCOPE_TYPE.COMMUNITY_LIST);
};

export const isCommunityLimitedAccess = ({ scopeTypes }: CommunityAccessParams): boolean => {
  if (!scopeTypes?.length) {
    return false;
  }

  return scopeTypes.includes(SCOPE_TYPE.COMMUNITY_LIST) && !scopeTypes.includes(SCOPE_TYPE.CHURCH);
};
